import { Box, Typography } from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";
import {
  applyEvent,
  CommonOrCommonRetirementFlug,
  DispDepositType,
  FormClassRetire,
  FormKbn,
  Prefectures,
  RetireReason,
  Status,
  DemanderKbn,
} from "../../assets/data/Constants";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkButton from "../../components/atoms/TkButton";
import TkDownloadLink from "../../components/atoms/TkDownloadLink";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkKikoStepper from "../../components/molecules/TkKikoStepper";
import TkDateDialog from "../../components/molecules/TkDateDialog";
import { BusinessContext } from "../../context/businessContext";
import "./_style.scss";
import { useLocation, useNavigate } from "react-router-dom";
import TkApprovalDateSymbolNumberRegistrationDialog from "../../components/molecules/TkApprovalDateSymbolNumberRegistrationDialog";
import TkMemo from "../../components/molecules/TkMemo";
import TkViewButtonJudgement from "../../components/molecules/TkViewButtonJudgement";
import { GlobalContext } from "../../context/globalContext";
import {
  IAPI_APP016_Request,
  IAPI_RET004_Response,
  IAPI_RET021_Request,
} from "../../type/apiType";
import { TkGetCode } from "../../utils/TkGetCode";
import {
  httpAPI_APP016,
  httpAPI_RET004,
  httpAPI_RET021,
  httpAPI_STA039,
} from "./api/request";
import { httpAPI_COM014 } from "../SCRW410001/api/request";
import { fakeTableList, fileDisplayMap, headList } from "./parts";
import {
  changeZipcodeFormat,
  isStatusAfterApproval,
  toNumberOrUndefined,
} from "../../utils/useTools";
import _ from "lodash";
import TkTableWithNoLine from "../../components/molecules/TkTableWithNoLine";
import { FormList } from "../../type/apiType/IAPI_RET004";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";

/**
 * SCRW410001_SCR0271_退職手当金の請求手続き（登録内容の確認）
 * @return SCRW410001 SCRW410001_SCR0271_退職手当金の請求手続き（登録内容の確認）
 */
const SCRW410001 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const locationState = location.state;
  const [memoCheck, setMemoCheck] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [stateTableList, setStateTableList] = useState<any>([]);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const { state, setState } = useContext(GlobalContext);
  const [statusCd, setStatusCd] = useState<any>();
  const [corpApplyKbn, setCorpApplyKbn] = useState<any>("1");
  const [defultData, setDefultData] = useState<any>();
  const [responseData, setResponseData] = useState<IAPI_RET004_Response>();
  const [memoData, setMemoData] = useState("");
  const [
    openLimitationAbolitionApprovalDate,
    setOpenLimitationAbolitionApprovalDate,
  ] = useState(false);
  const stateFakeTableListRef = useRef(_.cloneDeep(fakeTableList));
  const disabledReferBtn = useRef(false);
  const resRet004Ref = useRef<any>();
  const addBtnVisibleRef = useRef<boolean>(false);
  // 申請ID
  const applyId = locationState?.applyId ?? businessState?.job_35?.applyId;
  // 共済契約者番号
  const contractorNo =
    businessState?.common?.contractorNo || locationState?.contractorNo;
  const staffNo = locationState?.staffNo ?? businessState?.job_35?.staffNo;
  // 請求者区分
  let isRetiree = false;

  // システム日付
  const [tkMemoBodyList, setTkMemoBodyList] = useState<any>([]);
  const [bodyList, setBodyList] = useState<any>([]);
  const getTime = (start: any, end: any) => {
    const startYear = toNumberOrUndefined(start?.substring(0, 4)) ?? 0;
    const startMonth = toNumberOrUndefined(start?.substring(5, 7)) ?? 0;
    const endYear = toNumberOrUndefined(end?.substring(0, 4)) ?? 0;
    const endMonth = toNumberOrUndefined(end?.substring(5, 7)) ?? 0;
    if (endMonth > startMonth) {
      return endYear - startYear + 1;
    } else {
      return endYear - startYear;
    }
  };
  const getEarlierTime = (time1: any, time2: any) => {
    const time1Year = toNumberOrUndefined(time1?.substring(0, 4)) ?? 0;
    const time1Month = toNumberOrUndefined(time1?.substring(5, 7)) ?? 0;
    const time1Day = toNumberOrUndefined(time1?.substring(8, 10)) ?? 0;
    const time2Year = toNumberOrUndefined(time2?.substring(0, 4)) ?? 0;
    const time2Month = toNumberOrUndefined(time2?.substring(5, 7)) ?? 0;
    const time2Day = toNumberOrUndefined(time2?.substring(8, 10)) ?? 0;
    if (time1Year > time2Year) {
      return time2;
    } else if (time1Year < time2Year) {
      return time1;
    } else {
      if (time1Month > time2Month) {
        return time2;
      } else if (time1Month < time2Month) {
        return time1;
      } else {
        if (time1Day < time2Day) {
          return time1;
        } else if (time1Day > time2Day) {
          return time2;
        } else {
          return time1;
        }
      }
    }
  };
  const getMaxStart = (
    start1: any,
    start2: any,
    start3: any,
    end1: any,
    end2: any,
    end3: any
  ) => {
    const start1Data = new Date(start1);
    const start2Data = new Date(start2);
    const start3Data = new Date(start3);
    const end1Data = new Date(end1);
    const end2Data = new Date(end2);
    const end3Data = new Date(end3);
    const start1TimeStamp = start1Data.getTime();
    const start2TimeStamp = start2Data.getTime();
    const start3TimeStamp = start3Data.getTime();
    const end1TimeStamp = end1Data.getTime();
    const end2TimeStamp = end2Data.getTime();
    const end3TimeStamp = end3Data.getTime();
    const maxStart = Math.max(
      start1TimeStamp,
      start2TimeStamp,
      start3TimeStamp
    );
    const minEnd = Math.min(
      maxStart,
      end1TimeStamp,
      end2TimeStamp,
      end3TimeStamp
    );
    switch (maxStart) {
      case minEnd:
        return new Date(maxStart).toLocaleDateString();
    }
  };

  const getMinEnd = (
    start1: any,
    start2: any,
    start3: any,
    end1: any,
    end2: any,
    end3: any
  ) => {
    const start1Data = new Date(start1);
    const start2Data = new Date(start2);
    const start3Data = new Date(start3);
    const end1Data = new Date(end1);
    const end2Data = new Date(end2);
    const end3Data = new Date(end3);
    const start1TimeStamp = start1Data.getTime();
    const start2TimeStamp = start2Data.getTime();
    const start3TimeStamp = start3Data.getTime();
    const end1TimeStamp = end1Data.getTime();
    const end2TimeStamp = end2Data.getTime();
    const end3TimeStamp = end3Data.getTime();

    const minEnd = Math.min(end1TimeStamp, end2TimeStamp, end3TimeStamp);
    const maxStart = Math.max(
      minEnd,
      start1TimeStamp,
      start2TimeStamp,
      start3TimeStamp
    );
    switch (maxStart) {
      case minEnd:
        return new Date(minEnd).toLocaleDateString();
    }
  };

  const handleCheckExistFile = (
    fileList: FormList[],
    page: any,
    btnType: any
  ) => {
    if (btnType === "RETIREE") {
      return Object.values(fileList).some(
        (file) =>
          file.formClass ===
          FormClassRetire[
            `退職所得の源泉徴収票_手当金請求${page}枚目` as keyof typeof FormClassRetire
          ]
      );
    } else {
      return Object.values(fileList).some(
        (file) =>
          file.formClass ===
          FormClassRetire[
            `退職所得の源泉徴収票_退職届${page}枚目` as keyof typeof FormClassRetire
          ]
      );
    }
  };

  const buildWithholdingJob35State = (
    baseData: any,
    editPage: any,
    res: any,
    options: {
      editPageValue: any;
      retirementEditPageValue: any;
    }
  ) => {
    const mappedFileList = res.formList?.map((item: any) => ({
      serialNo: item.serialNo,
      facilityNo: item.facilityNo,
      fileList_staffNo: item.staffNo,
      formKbn: item.formKbn,
      formClass: item.formClass,
      fileName: item.fileName,
      fileBase64: item.fileBase64,
      formStatus: item.formStatus,
    }));

    const delFlg = baseData[`page${editPage}WamDelFlg`] === "1";

    return {
      ...baseData,
      editPage: options.editPageValue,
      retirementEditPage: options.retirementEditPageValue,
      [`page${editPage}Kbn`]: delFlg ? null : res[`page${editPage}Kbn`],
      [`page${editPage}PaymentAmt`]: delFlg
        ? null
        : res[`page${editPage}PaymentAmt`],
      [`page${editPage}WithholdingAmt`]: delFlg
        ? null
        : res[`page${editPage}WithholdingAmt`],
      [`page${editPage}ScAmtCity`]: delFlg
        ? null
        : res[`page${editPage}ScAmtCity`],
      [`page${editPage}ScAmtPrefecture`]: delFlg
        ? null
        : res[`page${editPage}ScAmtPrefecture`],
      [`page${editPage}LengthOfService`]: delFlg
        ? null
        : res[`page${editPage}LengthOfService`],
      [`page${editPage}EmployedDate`]: delFlg
        ? null
        : res[`page${editPage}EmployedDate`],
      [`page${editPage}RetiredDate`]: delFlg
        ? null
        : res[`page${editPage}RetiredDate`],
      [`page${editPage}DeductionPeriodYear`]: delFlg
        ? null
        : res[`page${editPage}DeductionPeriodYear`],
      [`page${editPage}DeductionPeriodMonth`]: delFlg
        ? null
        : res[`page${editPage}DeductionPeriodMonth`],
      fileList: mappedFileList,
      retirementFileList: mappedFileList,
    };
  };

  // 修正
  const handleFix = async (num: string, responseData: IAPI_RET004_Response) => {
    if (num === "1" || num === "2") {
      try {
        const res = await httpAPI_STA039({
          applyId,
        });

        setBusinessState({
          ...businessState,
          job_35: buildWithholdingJob35State(responseData, num, res, {
            editPageValue: num,
            retirementEditPageValue: "",
          }),
        });
      } catch (error) {
        navigate("/error");
      }
    } else {
      try {
        const res: any = await httpAPI_STA039({
          applyId: responseData?.retirementFormApplyId,
        });

        const finalRetirementEditPage = {
          "3": "1",
          "4": "2",
          "5": "3",
        }[num];

        if (res.resultCd === "I0000") {
          const retirementBaseData = {
            applyId: responseData?.applyId,
            retirementFormApplyId: res.applyId,
            retirementWithholdTaxSlipTotal: res.withholdTaxSlipTotal,
            retirementPage1Kbn: res.page1Kbn,
            retirementPage1PaymentAmt: res.page1PaymentAmt,
            retirementPage1WithholdingAmt: res.page1WithholdingAmt,
            retirementPage1ScAmtCity: res.page1ScAmtCity,
            retirementPage1ScAmtPrefecture: res.page1ScAmtPrefecture,
            retirementPage1LengthOfService: res.page1LengthOfService,
            retirementPage1EmployedDate: res.page1EmployedDate,
            retirementPage1RetiredDate: res.page1RetiredDate,
            retirementPage1DeductionPeriodYear: res.page1DeductionPeriodYear,
            retirementPage1DeductionPeriodMonth: res.page1DeductionPeriodMonth,
            retirementPage2Kbn: res.page2Kbn,
            retirementPage2PaymentAmt: res.page2PaymentAmt,
            retirementPage2WithholdingAmt: res.page2WithholdingAmt,
            retirementPage2ScAmtCity: res.page2ScAmtCity,
            retirementPage2ScAmtPrefecture: res.page2ScAmtPrefecture,
            retirementPage2LengthOfService: res.page2LengthOfService,
            retirementPage2EmployedDate: res.page2EmployedDate,
            retirementPage2RetiredDate: res.page2RetiredDate,
            retirementPage2DeductionPeriodYear: res.page2DeductionPeriodYear,
            retirementPage2DeductionPeriodMonth: res.page2DeductionPeriodMonth,
            retirementPage3Kbn: res.page3Kbn,
            retirementPage3PaymentAmt: res.page3PaymentAmt,
            retirementPage3WithholdingAmt: res.page3WithholdingAmt,
            retirementPage3ScAmtCity: res.page3ScAmtCity,
            retirementPage3ScAmtPrefecture: res.page3ScAmtPrefecture,
            retirementPage3LengthOfService: res.page3LengthOfService,
            retirementPage3EmployedDate: res.page3EmployedDate,
            retirementPage3RetiredDate: res.page3RetiredDate,
            retirementPage3DeductionPeriodYear: res.page3DeductionPeriodYear,
            retirementPage3DeductionPeriodMonth: res.page3DeductionPeriodMonth,
            retirementFileList: res.formList?.map((item: any) => ({
              serialNo: item.serialNo,
              facilityNo: item.facilityNo,
              fileList_staffNo: item.staffNo,
              formKbn: item.formKbn,
              formClass: item.formClass,
              fileName: item.fileName,
              fileBase64: item.fileBase64,
              formStatus: item.formStatus,
            })),
            duplicationLosYear: responseData.duplicationLosYear,
            duplicationLosFrom: responseData.duplicationLosFrom,
            duplicationLosTo: responseData.duplicationLosTo,
            retirementStaffName: responseData?.retirementStaffName,
          };

          setBusinessState({
            ...businessState,
            job_35: {
              ...retirementBaseData,
              retirementEditPage: finalRetirementEditPage,
            },
          });

          setState({
            ...state,
            errorMsgId: "",
          });
        } else {
          setState({
            ...state,
            errorMsgId: res.resultCd,
          });
        }
      } catch (error) {
        navigate("/error");
      }
    }

    navigate("/SCRR411112");
  };

  const getElm = (
    fileData: any,
    num: any,
    res: any,
    showButtons: boolean = true
  ) => {
    const normalizeBase64ForLink = (val: any): string | undefined => {
      if (val == null) return undefined;
      if (typeof val === "string") return val;
      // serialized Buffer like { type: 'Buffer', data: [...] }
      if (typeof val === "object") {
        if (val.type === "Buffer" && Array.isArray(val.data)) {
          const arr: number[] = val.data;
          let CHUNK = 0x8000;
          let binary = "";
          for (let i = 0; i < arr.length; i += CHUNK) {
            const chunk = arr.slice(i, i + CHUNK);
            binary += String.fromCharCode.apply(null, chunk as any);
          }
          try {
            return btoa(binary);
          } catch (e) {
            return undefined;
          }
        }
        if (Array.isArray(val) && val.every((v) => typeof v === "number")) {
          const arr: number[] = val;
          let CHUNK = 0x8000;
          let binary = "";
          for (let i = 0; i < arr.length; i += CHUNK) {
            const chunk = arr.slice(i, i + CHUNK);
            binary += String.fromCharCode.apply(null, chunk as any);
          }
          try {
            return btoa(binary);
          } catch (e) {
            return undefined;
          }
        }
        // nested props
        const tryProps = ["fileBase64", "base64", "file", "data", "payload"];
        for (const p of tryProps) {
          if (p in val) {
            return normalizeBase64ForLink(val[p]);
          }
        }
      }
      return undefined;
    };
    return (
      <Box className="downLinkBtn">
        <TkDownloadLink
          dataname={fileData.formName!}
          base64filedata={
            normalizeBase64ForLink(
              fileData.file ?? fileData.fileBase64 ?? fileData.base64 ?? null
            ) ?? ""
          }
          downloadBase64={true}
          onClick={(info: any) => fetchAndDownload(info, fileData, res)}
        />
        {showButtons && (
          <>
            <TkButton onClick={() => handleFix(num, res)}>修正</TkButton>
            <TkButton onClick={() => handleDelete(fileData, res)}>
              削除
            </TkButton>
          </>
        )}
      </Box>
    );
  };

  // クリック時にファイルを取得してダウンロードするハンドラ
  const fetchAndDownload = async (
    clickInfo: any,
    item: any,
    parentRes?: any
  ) => {
    try {
      // 既にファイルがあれば再利用
      let fileBase64: any =
        item.file ?? item.fileBase64 ?? item.base64filedata ?? null;

      const normalizeBase64 = (val: any): string | null => {
        if (!val && val !== 0) return null;
        if (typeof val === "string") return val;
        if (typeof val === "object") {
          if (typeof val.fileBase64 === "string") return val.fileBase64;
          if (typeof val.base64 === "string") return val.base64;
          if (typeof val.file === "string") return val.file;
          // nested
          return normalizeBase64(val.file ?? val.data ?? val.payload ?? null);
        }
        return null;
      };

      fileBase64 = normalizeBase64(fileBase64);
      let applyIdPrm;
      if (
        item.formClass ===
          FormClassRetire["退職所得の源泉徴収票_退職届1枚目"] ||
        item.formClass ===
          FormClassRetire["退職所得の源泉徴収票_退職届2枚目"] ||
        item.formClass === FormClassRetire["退職所得の源泉徴収票_退職届3枚目"]
      ) {
        applyIdPrm = parentRes?.retirementFormApplyId;
      } else {
        applyIdPrm = applyId;
      }

      if (!fileBase64) {
        // API 呼び出し
        const res: any = await httpAPI_COM014({
          applyId: applyIdPrm,
          formKbn: item.formKbn,
          formClass: item.formClass,
        });

        if (res.resultCd === "I0000") {
          // サーバ側が file を直接返す場合と、formList を返す場合に対応
          fileBase64 = normalizeBase64(
            res.fileBase64 ??
              (res.formList && res.formList[0] && res.formList[0].fileBase64) ??
              null
          );

          if (fileBase64) {
            // 個別保持のため、元データは上書きしない
          } else {
            // 正常結果だがファイルが無い場合
            setState({
              ...state,
              errorMsgId: "W3000",
            });
            return;
          }
        } else {
          setState({
            ...state,
            errorMsgId: res.resultCd,
          });
          return;
        }
      }

      // ダウンロード処理（base64 -> Blob -> ダウンロード）
      if (fileBase64 && typeof fileBase64 === "string") {
        const mimeMatch = fileBase64.match(/^data:(.*?);base64,/);
        const mimeType = mimeMatch ? mimeMatch[1] : "application/octet-stream";
        const base64Data = fileBase64.replace(/^data:.*;base64,/, "");

        const extension = mimeType ? "." + mimeType.split("/")[1] : "";
        let fileName = item.formName ?? item.dataname ?? "file";
        fileName = fileName.includes(".") ? fileName : fileName + extension;

        try {
          const byteCharacters = atob(base64Data);
          const byteNumbers = new Array(byteCharacters.length)
            .fill(null)
            .map((_, i) => byteCharacters.charCodeAt(i));
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: mimeType });

          const blobUrl = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = blobUrl;
          link.target = "_blank";
          link.rel = "nofollow noopener noreferrer";
          link.download = fileName;

          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(blobUrl);
        } catch (e) {
          // base64 形式でない等のエラー
          setState({
            ...state,
            errorMsgId: "W3000",
          });
          return;
        }
      }
    } catch (error) {
      navigate("/error");
    }
  };

  //追加ボタン押下
  const onClickAdd = async (resRet004: any, editPage: any, btnType: any) => {
    const nextBusinessState = {
      ...businessState,
      job_35: {
        applyId: resRet004?.applyId,
        retirementFormApplyId: resRet004?.retirementFormApplyId,
        retirementStaffName: resRet004?.retirementStaffName,
        editPage: btnType === "RETIREE" ? editPage : null,
        retirementEditPage: btnType === "ATTACHED" ? editPage : null,
      },
    };

    // 退職所得の源泉徴収票（1枚目）と、法人が添付した源泉徴収票（1～3枚目）の「追加」は参照画面へ遷移する
    if (
      (btnType === "RETIREE" && ["1", "2"].includes(String(editPage))) ||
      (btnType === "ATTACHED" && ["1", "2", "3"].includes(String(editPage)))
    ) {
      try {
        const res: any = await httpAPI_STA039({
          applyId:
            btnType === "RETIREE"
              ? resRet004?.applyId
              : resRet004?.retirementFormApplyId,
        });

        setBusinessState({
          ...businessState,
          job_35: {
            ...buildWithholdingJob35State(resRet004, editPage, res, {
              editPageValue: btnType === "RETIREE" ? editPage : null,
              retirementEditPageValue: btnType === "ATTACHED" ? editPage : null,
            }),
          },
        });

        navigate("/SCRR411112");
        return;
      } catch (error) {
        navigate("/error");
        return;
      }
    }

    //持ち回り情報を設定する
    setBusinessState(nextBusinessState);
    navigate("/SCRR411112");
  };

  // 追加ボタンを作成
  const handleSetAddBtnElm = (res: any, editPage: any, btnType: any) => {
    return (
      <Box>
        <TkButton onClick={() => onClickAdd(res, editPage, btnType)}>
          追加
        </TkButton>
      </Box>
    );
  };

  // 「機構にて削除」「追加ボタン」
  const handleSetDelAddBtnElm = (res: any, editPage: any, btnType: any) => {
    return (
      <Box className="upBtn">
        <Typography>機構にて削除</Typography>
        {addBtnVisibleRef.current && (
          <TkButton onClick={() => onClickAdd(res, editPage, btnType)}>
            追加
          </TkButton>
        )}
      </Box>
    );
  };

  const handleCheckAppearFileParts = (
    res: any,
    resRet004: any,
    resArr: ITkFakeTableLineProps[]
  ) => {
    const isAttachedTax1 = handleCheckExistFile(res.fileList!, "1", "ATTACHED");
    const isAttachedTax2 = handleCheckExistFile(res.fileList!, "2", "ATTACHED");
    const isAttachedTax3 = handleCheckExistFile(res.fileList!, "3", "ATTACHED");
    let attachedTax1 = resArr.find((item) => item.keyword === "attachedTax1")!;
    let attachedTax2 = resArr.find((item) => item.keyword === "attachedTax2")!;
    let attachedTax3 = resArr.find((item) => item.keyword === "attachedTax3")!;
    if (!isAttachedTax1) {
      //①１枚目が無し
      attachedTax1.showLine = true;
      if (
        !res.page1WamDelFlgFromContractor ||
        res.page1WamDelFlgFromContractor === "0"
      ) {
        //■削除フラグnullもしくは、削除フラグ（０）
        // 「受理待ち」「再受理待ち」の時「追加」
        attachedTax1.node =
          addBtnVisibleRef.current &&
          handleSetAddBtnElm(resRet004, "1", "ATTACHED");
        attachedTax1.showLine = addBtnVisibleRef.current;
      } else if (res.page1WamDelFlgFromContractor === "1") {
        //■削除フラグ１
        //・1枚目「機構にて削除」「追加ボタン」
        attachedTax1.node = handleSetDelAddBtnElm(resRet004, "1", "ATTACHED");
        if (isAttachedTax2 && isAttachedTax3) {
          //〇2枚目あり＆＆３枚目あり
          //・２枚目・３枚目「リンク」「修正」「削除」
          attachedTax2.showLine = true;
          attachedTax3.showLine = true;
        } else if (
          res.page2WamDelFlgFromContractor === "1" &&
          res.page3WamDelFlgFromContractor === "1"
        ) {
          // 〇2枚目削除フラグ（１）3枚目削除フラグ（１）
          // ・２枚目・３枚目「機構にて削除」「追加」
          attachedTax2.node = handleSetDelAddBtnElm(resRet004, "2", "ATTACHED");
          attachedTax2.showLine = true;
          attachedTax3.node = handleSetDelAddBtnElm(resRet004, "3", "ATTACHED");
          attachedTax3.showLine = true;
        } else if (isAttachedTax2 && !isAttachedTax3) {
          // 〇2枚目あり３枚目存在無し
          //・２枚目「リンク」「修正」「削除」
          attachedTax2.showLine = true;
          if (res.page3WamDelFlgFromContractor === "1") {
            //△3枚目削除フラグ（１）
            //・３枚目「機構にて削除」「追加」
            attachedTax3.node = handleSetDelAddBtnElm(
              resRet004,
              "3",
              "ATTACHED"
            );
            attachedTax3.showLine = true;
          } else if (res.page3WamDelFlgFromContractor === "0") {
            // △3枚目削除フラグ（0）
            // 「受理待ち」「再受理待ち」の時「追加」
            attachedTax3.node =
              addBtnVisibleRef.current &&
              handleSetAddBtnElm(resRet004, "3", "ATTACHED");
            attachedTax3.showLine = addBtnVisibleRef.current;
          }
        } else if (!isAttachedTax2 && isAttachedTax3) {
          //〇３枚目あり２枚目存在無し
          //・３枚目「リンク」「修正」「削除」
          attachedTax3.showLine = true;
          if (res.page2WamDelFlgFromContractor === "1") {
            // △2枚目削除フラグ（１）
            // ・２枚目「機構にて削除」「追加」
            attachedTax2.node = handleSetDelAddBtnElm(
              resRet004,
              "2",
              "ATTACHED"
            );
            attachedTax2.showLine = true;
          }
        }
      }
    }
    if (!isAttachedTax2) {
      //②（１枚目あり）2枚目無し
      if (res.page2WamDelFlgFromContractor === "0") {
        //■２枚目削除フラグ（０）
        //・「受理待ち」「再受理待ち」の場合２枚目「追加」
        attachedTax2.node =
          addBtnVisibleRef.current &&
          handleSetAddBtnElm(resRet004, "2", "ATTACHED");
        attachedTax2.showLine = addBtnVisibleRef.current;
        //・３枚目表示しない
        attachedTax3.showLine = false;
      } else if (res.page2WamDelFlgFromContractor === "1") {
        //■２枚目削除フラグ（１）
        //・２枚目「機構にて削除」「追加ボタン」
        attachedTax2.node = handleSetDelAddBtnElm(resRet004, "2", "ATTACHED");
        attachedTax2.showLine = true;
        if (isAttachedTax3) {
          //〇３枚目存在あり
          //・３枚目「リンク」「修正」「追加」
          attachedTax3.showLine = true;
        } else if (!isAttachedTax3) {
          //〇３枚目存在無し
          if (res.page3WamDelFlgFromContractor === "1") {
            //△削除フラグ（１）
            //・３枚目「機構にて削除」「追加」
            attachedTax3.node = handleSetDelAddBtnElm(
              resRet004,
              "3",
              "ATTACHED"
            );
            attachedTax3.showLine = true;
          }
        }
      }
    }
    if (!isAttachedTax3) {
      //③（１枚目存在あり）（２枚目存在あり）３枚目存在無し
      if (res.page3WamDelFlgFromContractor === "0") {
        //■３枚目削除フラグ（０）
        //・「受理待ち」「再受理待ち」の場合は３枚目「追加」
        attachedTax3.node =
          addBtnVisibleRef.current &&
          handleSetAddBtnElm(resRet004, "3", "ATTACHED");
        attachedTax3.showLine = addBtnVisibleRef.current;
      } else if (res.page3WamDelFlgFromContractor === "1") {
        //■３枚目削除フラグ（１）
        //・３枚目「機構にて削除」「追加」
        attachedTax3.node = handleSetDelAddBtnElm(resRet004, "3", "ATTACHED");
        attachedTax3.showLine = true;
      }
    }
  };

  const handleDelete = async (item: any, res: any) => {
    const paramData: IAPI_RET021_Request = {
      applyId: res?.applyId,
      fileList: [
        {
          serialNo: item.serialNo, // 連番
          facilityNo: item.facilityNo, // 施設番号
          staffNo: item.staffNo, // 職員番号
          formKbn: item.formKbn, // 帳票区分
          formClass: item.formClass, // 帳票種別
        },
      ],
    };
    try {
      const res = await httpAPI_RET021({
        ...paramData,
      });
      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        let resArr = stateFakeTableListRef.current;
        //区分（1枚目）
        resArr.find((item) => item.keyword === "page1Kbn")!.setDefaultValue =
          res.page1Kbn;
        //支払金額（1枚目）
        resArr.find(
          (item) => item.keyword === "page1PaymentAmt"
        )!.setDefaultValue = res.page1PaymentAmt;
        //源泉徴収額（1枚目）
        resArr.find(
          (item) => item.keyword === "page1WithholdingAmt"
        )!.setDefaultValue = res.page1WithholdingAmt;
        //特別徴収税額:市町村民税（1枚目）
        resArr.find(
          (item) => item.keyword === "page1ScAmtCity"
        )!.setDefaultValue = res.page1ScAmtCity;
        //特別徴収税額:都道府県税（1枚目）
        resArr.find(
          (item) => item.keyword === "page1ScAmtPrefecture"
        )!.setDefaultValue = res.page1ScAmtPrefecture;
        //勤続年数（1枚目）
        resArr.find(
          (item) => item.keyword === "page1LengthOfService"
        )!.setDefaultValue = res.page1LengthOfService;
        //就労年月日（1枚目）
        resArr.find(
          (item) => item.keyword === "page1EmployedDate"
        )!.setDefaultValue = res.page1EmployedDate;
        //退職年月日（1枚目）
        resArr.find(
          (item) => item.keyword === "page1RetiredDate"
        )!.setDefaultValue = res.page1RetiredDate;
        //区分（2枚目）
        resArr.find((item) => item.keyword === "page2Kbn")!.setDefaultValue =
          res.page2Kbn;
        //支払金額（2枚目）
        resArr.find(
          (item) => item.keyword === "page2PaymentAmt"
        )!.setDefaultValue = res.page2PaymentAmt;
        //源泉徴収額（2枚目）
        resArr.find((item) => item.keyword === "page2Tax")!.setDefaultValue =
          res.page2WithholdingAmt;
        //特別徴収税額:市町村民税（2枚目）
        resArr.find(
          (item) => item.keyword === "page2ScAmtCity"
        )!.setDefaultValue = res.page2ScAmtCity;
        //特別徴収税額:都道府県税（2枚目）
        resArr.find(
          (item) => item.keyword === "page2ScAmtPrefecture"
        )!.setDefaultValue = res.page2ScAmtPrefecture;
        //勤続年数（2枚目）
        resArr.find(
          (item) => item.keyword === "page2LengthOfService"
        )!.setDefaultValue = res.page2LengthOfService;
        //就労年月日（2枚目）
        resArr.find(
          (item) => item.keyword === "page2EmployedDate"
        )!.setDefaultValue = res.page2EmployedDate;
        //退職年月日（2枚目）
        resArr.find(
          (item) => item.keyword === "page2RetiredDate"
        )!.setDefaultValue = res.page2RetiredDate;
        if (res.page1WamDelFlg === "1") {
          //退職所得の源泉徴収票（1枚目）
          resArr.find((item) => item.keyword === "page1RetireeTax")!.showLine =
            true;
          // 就労年月日（1枚目）
          resArr.find(
            (item) => item.keyword === "page1EmployedDate"
          )!.showLine = false;
          // 退職年月日（1枚目）
          resArr.find((item) => item.keyword === "page1RetiredDate")!.showLine =
            false;
          // 区分（1枚目）
          resArr.find((item) => item.keyword === "page1Kbn")!.showLine = false;
          // 支払金額（1枚目）
          resArr.find((item) => item.keyword === "page1PaymentAmt")!.showLine =
            false;
          // 源泉徴収額（1枚目）
          resArr.find(
            (item) => item.keyword === "page1WithholdingAmt"
          )!.showLine = false;
          // 特別徴収税額:市町村民税（1枚目）
          resArr.find((item) => item.keyword === "page1ScAmtCity")!.showLine =
            false;
          // 特別徴収税額:都道府県税（1枚目）
          resArr.find(
            (item) => item.keyword === "page1ScAmtPrefecture"
          )!.showLine = false;
          // 勤続年数（1枚目）
          resArr.find(
            (item) => item.keyword === "page1LengthOfService"
          )!.showLine = false;
          //1枚目の控除期間（年）
          resArr.find(
            (item) => item.keyword === "page1DeductionPeriodYear"
          )!.showLine = false;
          //1枚目の控除期間（月）
          resArr.find(
            (item) => item.keyword === "page1DeductionPeriodMonth"
          )!.showLine = false;
        }
        if (res.page2WamDelFlg === "1") {
          //退職所得の源泉徴収票（2枚目）
          resArr.find((item) => item.keyword === "page2RetireeTax")!.showLine =
            true;
          // 就労年月日（2枚目）
          resArr.find(
            (item) => item.keyword === "page2EmployedDate"
          )!.showLine = false;
          // 退職年月日（2枚目）
          resArr.find((item) => item.keyword === "page2RetiredDate")!.showLine =
            false;
          // 区分（2枚目）
          resArr.find((item) => item.keyword === "page2Kbn")!.showLine = false;
          // 支払金額（2枚目）
          resArr.find((item) => item.keyword === "page2PaymentAmt")!.showLine =
            false;
          // 源泉徴収額（2枚目）
          resArr.find((item) => item.keyword === "page2Tax")!.showLine = false;
          // 特別徴収税額:市町村民税（2枚目）
          resArr.find((item) => item.keyword === "page2ScAmtCity")!.showLine =
            false;
          // 特別徴収税額:都道府県税（2枚目）
          resArr.find(
            (item) => item.keyword === "page2ScAmtPrefecture"
          )!.showLine = false;
          // 勤続年数（2枚目）
          resArr.find(
            (item) => item.keyword === "page2LengthOfService"
          )!.showLine = false;
          //2枚目の控除期間（年）
          resArr.find(
            (item) => item.keyword === "page2DeductionPeriodYear"
          )!.showLine = false;
          //2枚目の控除期間（月）
          resArr.find(
            (item) => item.keyword === "page2DeductionPeriodMonth"
          )!.showLine = false;
        }

        let page1RetireeTax = resArr.find(
          (item) => item.keyword === "page1RetireeTax"
        )!;
        let page2RetireeTax = resArr.find(
          (item) => item.keyword === "page2RetireeTax"
        )!;
        const isPage1RetireeTax = handleCheckExistFile(
          res.fileList!,
          "1",
          "RETIREE"
        );
        const isPage2RetireeTax = handleCheckExistFile(
          res.fileList!,
          "2",
          "RETIREE"
        );

        if (!isPage1RetireeTax && !isPage2RetireeTax) {
          const duplicationLosYear = resArr.find(
            (item) => item.keyword === "duplicationLosYear"
          )!;
          duplicationLosYear.showLine = false;
          const duplicationLos = resArr.find(
            (item) => item.keyword === "duplicationLos"
          )!;
          duplicationLos.showLine = false;
        }

        if (res.page1WamDelFlg === "1" && res.page2WamDelFlg === "1") {
          page1RetireeTax.showLine = true;
          page1RetireeTax.node = handleSetDelAddBtnElm(
            resRet004Ref.current,
            "1",
            "RETIREE"
          );
          page2RetireeTax.showLine = true;
          page2RetireeTax.node = handleSetDelAddBtnElm(
            resRet004Ref.current,
            "2",
            "RETIREE"
          );
        } else if (!isPage1RetireeTax) {
          //1枚目のフォームクラス41なかったら（添付なし）
          page1RetireeTax.showLine = true;
          if (res.page1WamDelFlg === "1") {
            //削除フラグあり１→「機構ににて削除」「追加」
            page1RetireeTax.node = handleSetDelAddBtnElm(
              resRet004Ref.current,
              "1",
              "RETIREE"
            );
            if (!isPage2RetireeTax) {
              page2RetireeTax.showLine = false;
            }
          } else if (res.page1WamDelFlg === "0" || !res.page1WamDelFlg) {
            //削除フラグなし０
            page1RetireeTax.node =
              addBtnVisibleRef.current &&
              handleSetAddBtnElm(resRet004Ref.current, "1", "RETIREE");
            page1RetireeTax.showLine = addBtnVisibleRef.current;
            page2RetireeTax.showLine = false;
          }
        } else if (!isPage2RetireeTax) {
          // 2枚目のフォームクラス42なかったら（添付なし）
          if (res.page2WamDelFlg === "1") {
            // res.page1WamDelFlg === "1"の時は非表示
            if (res.page1WamDelFlg === "1") {
              page2RetireeTax.showLine = false;
            } else {
              // 　・削除フラグあり１→「機構ににて削除」「追加」
              page2RetireeTax.node = handleSetDelAddBtnElm(
                resRet004Ref.current,
                "2",
                "RETIREE"
              );
              page2RetireeTax.showLine = true;
            }
          } else if (res.page2WamDelFlg === "0") {
            // 　・削除フラグなし０→
            if (res.page1WamDelFlg === "1") {
              // res.page1WamDelFlg === "1"の時は非表示
              page2RetireeTax.showLine = false;
            } else if (isPage1RetireeTax) {
              //1枚目合ったら
              page2RetireeTax.node =
                addBtnVisibleRef.current &&
                handleSetAddBtnElm(resRet004Ref.current, "2", "RETIREE");
              page2RetireeTax.showLine = addBtnVisibleRef.current;
            }
          }
        }

        handleCheckAppearFileParts(res, resRet004Ref.current, resArr);
        setStateTableList([...resArr]);
        handleInit();
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handleInit = async () => {
    try {
      const res = await httpAPI_RET004({
        applyId,
        contractorNo,
        staffNo,
      });
      if (res.resultCd === "I0000") {
        resRet004Ref.current = res;
        addBtnVisibleRef.current =
          res.latestApplyStatus === Status["受理待ち"] ||
          res.latestApplyStatus === Status["再受理待ち"];

        if (
          (res.latestApplyStatus === Status["受理待ち"] ||
            res.latestApplyStatus === Status["再受理待ち"]) &&
          res.limitationFlg === "1"
        ) {
          setState({
            ...state,
            errorMsgId: "TKMSG_SCR0021W",
          });
        } else {
          setState({
            ...state,
            errorMsgId: "",
          });
        }
        setResponseData(res);
        setStatusCd(res.latestApplyStatus);
        setCorpApplyKbn(res.corpApplyKbn);
        disabledReferBtn.current = !res.retirementFormApplyId ? true : false;
        let resArr = stateFakeTableListRef.current;

        for (let i in res) {
          let index = i as keyof typeof res;
          let targetObj = resArr.find((item) => item.keyword === i)!;

          if (i === "depositType") {
            if (
              (res.latestApplyStatus === Status["届出待ち"] ||
                res.latestApplyStatus === Status["差戻し一時保存"]) &&
              targetObj
            ) {
              targetObj.setDefaultValue = DispDepositType["普通"];
            } else {
              res.depositType === DispDepositType["普通"] &&
                (targetObj.setDefaultValue = DispDepositType["普通"]);
            }
          } else {
            if (targetObj) {
              targetObj.setDefaultValue = res[index];
              targetObj.type === "text" && (targetObj.text = res[index]);
            }
          }
        }
        // 勤務先
        resArr.find((item) => item.keyword === "facilityName")!.text =
          res.finalFacilityNo === "999"
            ? `${res?.finalFacilityNo}:対象外施設`
            : `${res.finalFacilityNo ?? ""}:${res.facilityName ?? ""}`;

        isRetiree = res?.demanderKbn === DemanderKbn["退職者本人"];

        // 被共済職員期間
        resArr.find((item) => item.keyword === "maePeriod")!.text =
          (res.maePeriodYear ?? "") +
          "年" +
          (res.maePeriodMonth ?? "") +
          "ヶ月";

        // 退職理由
        resArr.find((item) => item.keyword === "retirementReason")!.text =
          TkGetCode(RetireReason, res.retirementReason);

        // 請求者現住所（郵便番号）
        resArr.find((item) => item.keyword === "demanderZipcode")!.text =
          changeZipcodeFormat(res.demanderZipcode);

        // 請求者現住所
        resArr.find((item) => item.keyword === "demanderCity")!.text =
          (TkGetCode(Prefectures, res.demanderPrefectureCd!) ?? "") +
          (res.demanderCity ?? "") +
          (res.demanderAddressOthers ?? "");

        // 氏名
        resArr.find(
          (item) => item.keyword === "retirementStaffName"
        )!.setDefaultValue = isRetiree ? res.demanderName : res.staffNameKanji;

        // 現住所
        resArr.find((item) => item.keyword === "nowAddress")!.valueObject = {
          prefectures: TkGetCode(Prefectures, res.nowPrefectureCd!),
          city: res.nowAddressCity ?? "",
          address: res.nowAddressOthers ?? "",
        };

        // その年１月１日現在の住所
        resArr.find(
          (item) => item.keyword === "yearOneToOnelocation"
        )!.valueObject = {
          prefectures: TkGetCode(
            Prefectures,
            res.retirementYearFirstPrefectureCd!
          ),
          city: res.retirementYearFirstAddressCity ?? "",
          address: res.retirementYearAddressOthers ?? "",
        };

        // 海外送金
        if (!!res.domesticResidenceFlg) {
          resArr.find(
            (item) => item.keyword === "sendMoneyAbroad"
          )!.setDefaultValue = ["海外送金"];
        }

        // 【A】③　この申告書の提出先から受ける退職手当等についての勤続期間
        let joinAndRetireDate = resArr.find(
          (item) => item.keyword === "joinAndRetireDate"
        )!;
        joinAndRetireDate.start = {
          wantToSetValue: res.firstJoinDate,
          disabled: true,
        };
        joinAndRetireDate.end = {
          wantToSetValue: res.retireDate,
          disabled: true,
        };

        //【B】④本年中に支払を受けた他の退職手当等についての勤続期間
        let currentYearLos = resArr.find(
          (item) => item.keyword === "currentYearLos"
        )!;
        currentYearLos.start = {
          wantToSetValue: res.currentYearLosFrom,
          disabled: true,
        };
        currentYearLos.end = {
          wantToSetValue: res.currentYearLosTo,
          disabled: true,
        };

        // 【B】⑤　③と④の通算勤続期間
        let areaBNo5 = resArr.find((item) => item.keyword === "areaBNo5")!;
        areaBNo5.start = {
          wantToSetValue: getEarlierTime(
            res.firstJoinDate,
            res.currentYearLosFrom
          ),
          disabled: true,
        };
        areaBNo5.end = {
          wantToSetValue: getEarlierTime(res.retireDate, res.currentYearLosTo),
          disabled: true,
        };

        // 【D】⑧　Ａの退職手当等についての勤続期間（③）に通算された前の退職手当等についての勤続期間
        let pastLosInCurrentYearTotal = resArr.find(
          (item) => item.keyword === "pastLosInCurrentYearTotal"
        )!;
        pastLosInCurrentYearTotal.start = {
          wantToSetValue: res.pastLosInCurrentYearTotalFrom,
          disabled: true,
        };
        pastLosInCurrentYearTotal.end = {
          wantToSetValue: res.pastLosInCurrentYearTotalTo,
          disabled: true,
        };

        // 【D】⑨　Ｂの退職手当等についての勤続期間（④）に通算された前の退職手当等についての勤続期間
        let pastLosInCurrentYearOther = resArr.find(
          (item) => item.keyword === "pastLosInCurrentYearOther"
        )!;
        pastLosInCurrentYearOther.start = {
          wantToSetValue: res.pastLosInCurrentYearOtherFrom,
          disabled: true,
        };
        pastLosInCurrentYearOther.end = {
          wantToSetValue: res.pastLosInCurrentYearOtherTo,
          disabled: true,
        };

        //【C】⑥　前年以前４年内に支払を受けた他の退職手当等についての勤続期間
        let past4yearsLos = resArr.find(
          (item) => item.keyword === "past4yearsLos"
        )!;
        past4yearsLos.start = {
          wantToSetValue: res.past4yearsLosFrom,
          disabled: true,
        };
        past4yearsLos.end = {
          wantToSetValue: res.past4yearsLosTo,
          disabled: true,
        };

        // 【E】区分B　支払者の所在地（住所）
        resArr.find(
          (item) => item.keyword === "currentYearPayerAddress"
        )!.valueObject = {
          prefectures: TkGetCode(Prefectures, res.currentYearPayerPrefectureCd),
          city: res.currentYearPayerAddressCity ?? "",
          address: res.currentYearPayerAddressOthers ?? "",
        };

        //【E】区分C　支払者の所在地（住所）
        resArr.find(
          (item) => item.keyword === "past4yearsPayerAddress"
        )!.valueObject = {
          prefectures: TkGetCode(Prefectures, res.past4yearsPayerPrefectureCd),
          city: res.past4yearsPayerAddressCity ?? "",
          address: res.past4yearsPayerAddressOthers ?? "",
        };

        switch (res.page1WamDelFlg) {
          case "0":
            //区分（1枚目）
            resArr.find(
              (item) => item.keyword === "page1Kbn"
            )!.setDefaultValue = res.page1Kbn;
            //支払金額（1枚目）
            resArr.find(
              (item) => item.keyword === "page1PaymentAmt"
            )!.setDefaultValue = res.page1PaymentAmt;
            //源泉徴収額（1枚目）
            resArr.find(
              (item) => item.keyword === "page1WithholdingAmt"
            )!.setDefaultValue = res.page1WithholdingAmt;
            //特別徴収税額:市町村民税（1枚目）
            resArr.find(
              (item) => item.keyword === "page1ScAmtCity"
            )!.setDefaultValue = res.page1ScAmtCity;
            //特別徴収税額:都道府県税（1枚目）
            resArr.find(
              (item) => item.keyword === "page1ScAmtPrefecture"
            )!.setDefaultValue = res.page1ScAmtPrefecture;
            //勤続年数（1枚目）
            resArr.find(
              (item) => item.keyword === "page1LengthOfService"
            )!.setDefaultValue = res.page1LengthOfService;
            //就労年月日（1枚目）
            resArr.find(
              (item) => item.keyword === "page1EmployedDate"
            )!.setDefaultValue = res.page1EmployedDate;
            //退職年月日（1枚目）
            resArr.find(
              (item) => item.keyword === "page1RetiredDate"
            )!.setDefaultValue = res.page1RetiredDate;
            //1枚目の控除期間（年）
            resArr.find(
              (item) => item.keyword === "page1DeductionPeriodYear"
            )!.setDefaultValue = res?.page1DeductionPeriodYear;
            //1枚目の控除期間（月）
            resArr.find(
              (item) => item.keyword === "page1DeductionPeriodMonth"
            )!.setDefaultValue = res?.page1DeductionPeriodMonth;
            break;
        }
        switch (res.page2WamDelFlg) {
          case "0":
            //区分（2枚目）
            resArr.find(
              (item) => item.keyword === "page2Kbn"
            )!.setDefaultValue = res.page2Kbn;
            //支払金額（2枚目）
            resArr.find(
              (item) => item.keyword === "page2PaymentAmt"
            )!.setDefaultValue = res.page2PaymentAmt;
            //源泉徴収額（2枚目）
            resArr.find(
              (item) => item.keyword === "page2Tax"
            )!.setDefaultValue = res.page2WithholdingAmt;
            //特別徴収税額:市町村民税（2枚目）
            resArr.find(
              (item) => item.keyword === "page2ScAmtCity"
            )!.setDefaultValue = res.page2ScAmtCity;
            //特別徴収税額:都道府県税（2枚目）
            resArr.find(
              (item) => item.keyword === "page2ScAmtPrefecture"
            )!.setDefaultValue = res.page2ScAmtPrefecture;
            //勤続年数（2枚目）
            resArr.find(
              (item) => item.keyword === "page2LengthOfService"
            )!.setDefaultValue = res.page2LengthOfService;
            //就労年月日（2枚目）
            resArr.find(
              (item) => item.keyword === "page2EmployedDate"
            )!.setDefaultValue = res.page2EmployedDate;
            //退職年月日（2枚目）
            resArr.find(
              (item) => item.keyword === "page2RetiredDate"
            )!.setDefaultValue = res.page2RetiredDate;
            //2枚目の控除期間（年）
            resArr.find(
              (item) => item.keyword === "page2DeductionPeriodYear"
            )!.setDefaultValue = res?.page2DeductionPeriodYear;
            //2枚目の控除期間（月）
            resArr.find(
              (item) => item.keyword === "page2DeductionPeriodMonth"
            )!.setDefaultValue = res?.page2DeductionPeriodMonth;
            break;
        }

        // メモ欄
        let bodyList = res.memoList?.map((item: any) => [
          {
            children: item.managerName,
          },
          {
            children: item.process,
          },
          {
            children: item.createDate,
          },
          {
            children: item.processComment,
          },
        ]);
        setTkMemoBodyList(bodyList);

        const editableStatus =
          res.latestApplyStatus === Status["受理待ち"] ||
          res.latestApplyStatus === Status["再受理待ち"];

        const page1RetireeTaxfile = res.fileList?.find(
          (item) =>
            item.formClass ===
            FormClassRetire["退職所得の源泉徴収票_手当金請求1枚目"]
        );
        const page1ShowItem =
          res.page1WamDelFlg !== "1" && !!page1RetireeTaxfile;

        const page2RetireeTaxfile = res.fileList?.find(
          (item) =>
            item.formClass ===
            FormClassRetire["退職所得の源泉徴収票_手当金請求2枚目"]
        );
        if (page1RetireeTaxfile || page2RetireeTaxfile) {
          //重複勤続年数
          const duplicationLosYear = resArr.find(
            (item) => item.keyword === "duplicationLosYear"
          )!;
          duplicationLosYear.setDefaultValue = res?.duplicationLosYear
            ? res?.duplicationLosYear
            : "";
          duplicationLosYear.showLine = true;

          //重複期間
          const duplicationLos = resArr.find(
            (item) => item.keyword === "duplicationLos"
          )!;
          duplicationLos.disabled = true;
          duplicationLos.showLine = true;
          duplicationLos.start = {
            wantToSetValue: res?.duplicationLosFrom,
            disabled: true,
          };
          duplicationLos.end = {
            wantToSetValue: res?.duplicationLosTo,
            disabled: true,
          };
        }
        const page2ShowItem =
          !(res.page2WamDelFlg === "1") && !!page2RetireeTaxfile;
        // (ⅵ)源泉徴収票関連項目 の表示制御
        resArr.find((item) => item.keyword === "page1RetireeTax")!.showLine =
          true;
        if (res?.page1WamDelFlg !== "1" && page1ShowItem) {
          resArr.find((item) => item.keyword === "page1RetireeTax")!.node =
            getElm(page1RetireeTaxfile, "1", res, editableStatus);
        }
        // 就労年月日（1枚目）
        resArr.find((item) => item.keyword === "page1EmployedDate")!.showLine =
          page1ShowItem;
        // 退職年月日（1枚目）
        resArr.find((item) => item.keyword === "page1RetiredDate")!.showLine =
          page1ShowItem;
        // 区分（1枚目）
        resArr.find((item) => item.keyword === "page1Kbn")!.showLine =
          page1ShowItem;
        // 支払金額（1枚目）
        resArr.find((item) => item.keyword === "page1PaymentAmt")!.showLine =
          page1ShowItem;
        // 源泉徴収額（1枚目）
        resArr.find(
          (item) => item.keyword === "page1WithholdingAmt"
        )!.showLine = page1ShowItem;
        // 特別徴収税額:市町村民税（1枚目）
        resArr.find((item) => item.keyword === "page1ScAmtCity")!.showLine =
          page1ShowItem;
        // 特別徴収税額:都道府県税（1枚目）
        resArr.find(
          (item) => item.keyword === "page1ScAmtPrefecture"
        )!.showLine = page1ShowItem;
        // 勤続年数（1枚目）
        resArr.find(
          (item) => item.keyword === "page1LengthOfService"
        )!.showLine = page1ShowItem;
        //1枚目の控除期間（年）
        resArr.find(
          (item) => item.keyword === "page1DeductionPeriodYear"
        )!.showLine = page1ShowItem;
        //1枚目の控除期間（月）
        resArr.find(
          (item) => item.keyword === "page1DeductionPeriodMonth"
        )!.showLine = page1ShowItem;

        resArr.find((item) => item.keyword === "page2RetireeTax")!.showLine =
          true;
        if (res?.page2WamDelFlg === "0" && page2ShowItem) {
          resArr.find((item) => item.keyword === "page2RetireeTax")!.node =
            getElm(page2RetireeTaxfile, "2", res, editableStatus);
        }
        // 就労年月日（2枚目）
        resArr.find((item) => item.keyword === "page2EmployedDate")!.showLine =
          page2ShowItem;
        // 退職年月日（2枚目）
        resArr.find((item) => item.keyword === "page2RetiredDate")!.showLine =
          page2ShowItem;
        // 区分（2枚目）
        resArr.find((item) => item.keyword === "page2Kbn")!.showLine =
          page2ShowItem;
        // 支払金額（2枚目）
        resArr.find((item) => item.keyword === "page2PaymentAmt")!.showLine =
          page2ShowItem;
        // 源泉徴収額（2枚目）
        resArr.find((item) => item.keyword === "page2Tax")!.showLine =
          page2ShowItem;
        // 特別徴収税額:市町村民税（2枚目）
        resArr.find((item) => item.keyword === "page2ScAmtCity")!.showLine =
          page2ShowItem;
        // 特別徴収税額:都道府県税（2枚目）
        resArr.find(
          (item) => item.keyword === "page2ScAmtPrefecture"
        )!.showLine = page2ShowItem;
        // 勤続年数（2枚目）
        resArr.find(
          (item) => item.keyword === "page2LengthOfService"
        )!.showLine = page2ShowItem;
        //2枚目の控除期間（年）
        resArr.find(
          (item) => item.keyword === "page2DeductionPeriodYear"
        )!.showLine = page2ShowItem;
        //2枚目の控除期間（月）
        resArr.find(
          (item) => item.keyword === "page2DeductionPeriodMonth"
        )!.showLine = page2ShowItem;

        const showFile = (key: string, file: FormList) => {
          if (fileDisplayMap[key].includes(res.identificationDocsKind!)) {
            let target = resArr.find((item) => item.keyword === key)!;
            target.showLine = true;
            target.dataname = file.formName;
            target.base64filedata = file?.file;
            try {
              target.onClick = (info: any) => fetchAndDownload(info, file, res);
            } catch (e) {
              // ignore
            }
          }
        };

        res.fileList?.forEach((fileItem, index) => {
          switch (fileItem.formKbn) {
            case FormKbn["退職書類"]:
              switch (fileItem.formClass) {
                case FormClassRetire["「死亡診断書」又は「死体検案書」（写）"]:
                  let deathOrAutopsyReport = resArr.find(
                    (item) => item.keyword === "deathOrAutopsyReport"
                  )!;
                  deathOrAutopsyReport.dataname = fileItem.formName;
                  deathOrAutopsyReport.base64filedata = fileItem.file;
                  deathOrAutopsyReport.showLine = true;
                  try {
                    deathOrAutopsyReport.onClick = (info: any) =>
                      fetchAndDownload(info, fileItem, res);
                  } catch (e) {}
                  break;

                case FormClassRetire["生計維持に関する調査書（様式11号）"]:
                  let marriageReport = resArr.find(
                    (item) => item.keyword === "marriageReport"
                  )!;
                  marriageReport.dataname = fileItem.formName;
                  marriageReport.base64filedata = fileItem.file;
                  marriageReport.showLine = true;
                  try {
                    marriageReport.onClick = (info: any) =>
                      fetchAndDownload(info, fileItem, res);
                  } catch (e) {}
                  break;

                case FormClassRetire["職員の死亡当時の住民票の謄本"]:
                  let certificateOfResidence = resArr.find(
                    (item) => item.keyword === "certificateOfResidence"
                  )!;
                  certificateOfResidence.dataname = fileItem.formName;
                  certificateOfResidence.base64filedata = fileItem.file;
                  certificateOfResidence.showLine = true;
                  try {
                    certificateOfResidence.onClick = (info: any) =>
                      fetchAndDownload(info, fileItem, res);
                  } catch (e) {}
                  break;

                case FormClassRetire["事実上の配偶者であることを証明する書類"]:
                  let claimantPartnerBook = resArr.find(
                    (item) => item.keyword === "claimantPartnerBook"
                  )!;
                  claimantPartnerBook.dataname = fileItem.formName;
                  claimantPartnerBook.base64filedata = fileItem.file;
                  claimantPartnerBook.showLine = true;
                  try {
                    claimantPartnerBook.onClick = (info: any) =>
                      fetchAndDownload(info, fileItem, res);
                  } catch (e) {}
                  break;

                case FormClassRetire["本人確認書類"]:
                  if (
                    resArr.find((item) => item.keyword === "identityDocs1")!
                      .showLine
                  ) {
                    showFile("identityDocs2", fileItem);
                  } else {
                    showFile("identityDocs1", fileItem);
                  }
                  break;

                case FormClassRetire["本人確認書類（表面）"]:
                  showFile("identityDocHead", fileItem);
                  break;

                case FormClassRetire["本人確認書類（裏面）"]:
                  showFile("identityDocTail", fileItem);
                  break;

                case FormClassRetire["死亡した退職者の個人番号を確認する書類"]:
                  if (res.demanderKbn === DemanderKbn["遺族"]) {
                    let deceasedRetireeNumCheckDoc = resArr.find(
                      (item) => item.keyword === "deceasedRetireeNumCheckDoc"
                    )!;
                    deceasedRetireeNumCheckDoc.dataname = fileItem.formName;
                    deceasedRetireeNumCheckDoc.base64filedata = fileItem.file;
                    deceasedRetireeNumCheckDoc.showLine = true;
                    try {
                      deceasedRetireeNumCheckDoc.onClick = (info: any) =>
                        fetchAndDownload(info, fileItem, res);
                    } catch (e) {}
                  }
                  break;

                case FormClassRetire["旧姓と新姓が確認できる住民票"]:
                  let nameConfirmation = resArr.find(
                    (item) => item.keyword === "nameConfirmation"
                  )!;
                  nameConfirmation.dataname = fileItem.formName;
                  nameConfirmation.base64filedata = fileItem.file;
                  nameConfirmation.showLine = true;
                  try {
                    nameConfirmation.onClick = (info: any) =>
                      fetchAndDownload(info, fileItem, res);
                  } catch (e) {}
                  break;

                case FormClassRetire["個人番号を確認する書類"]:
                  let numberCheckDoc = resArr.find(
                    (item) => item.keyword === "numberCheckDoc"
                  )!;
                  numberCheckDoc.dataname = fileItem.formName;
                  numberCheckDoc.base64filedata = fileItem.file;
                  numberCheckDoc.showLine = true;
                  try {
                    numberCheckDoc.onClick = (info: any) =>
                      fetchAndDownload(info, fileItem, res);
                  } catch (e) {}
                  break;

                case FormClassRetire["振込先口座が確認できる書類"]:
                  let payAccountCheckDoc = resArr.find(
                    (item) => item.keyword === "payAccountCheckDoc"
                  )!;
                  payAccountCheckDoc.dataname = fileItem.formName;
                  payAccountCheckDoc.base64filedata = fileItem.file;
                  payAccountCheckDoc.showLine = true;
                  try {
                    payAccountCheckDoc.onClick = (info: any) =>
                      fetchAndDownload(info, fileItem, res);
                  } catch (e) {}
                  break;

                case FormClassRetire["振込先金融口座が確認できる書類"]:
                  let financialAccountConfirm = resArr.find(
                    (item) => item.keyword === "financialAccountConfirm"
                  )!;
                  financialAccountConfirm.dataname = fileItem.formName;
                  financialAccountConfirm.base64filedata = fileItem.file;
                  financialAccountConfirm.showLine = true;
                  try {
                    financialAccountConfirm.onClick = (info: any) =>
                      fetchAndDownload(info, fileItem, res);
                  } catch (e) {}
                  break;

                case FormClassRetire[
                  "氏名が変更されていることを確認できる書類"
                ]:
                  let nameChangedConfirm = resArr.find(
                    (item) => item.keyword === "nameChangedConfirm"
                  )!;
                  nameChangedConfirm.dataname = fileItem.formName;
                  nameChangedConfirm.base64filedata = fileItem.file;
                  nameChangedConfirm.showLine = true;
                  try {
                    nameChangedConfirm.onClick = (info: any) =>
                      fetchAndDownload(info, fileItem, res);
                  } catch (e) {}
                  break;

                case FormClassRetire["委任状"]:
                  let commission = resArr.find(
                    (item) => item.keyword === "commission"
                  )!;
                  commission.dataname = fileItem.formName;
                  commission.base64filedata = fileItem.file;
                  commission.showLine = true;
                  try {
                    commission.onClick = (info: any) =>
                      fetchAndDownload(info, fileItem, res);
                  } catch (e) {}
                  break;

                case FormClassRetire["退職所得の源泉徴収票_退職届1枚目"]:
                  let attachedTax1 = resArr.find(
                    (item) => item.keyword === "attachedTax1"
                  )!;
                  attachedTax1.showLine = true;
                  if (
                    res.page1WamDelFlgFromContractor === "0" &&
                    editableStatus
                  ) {
                    attachedTax1.node = getElm(res.fileList![index], "3", res);
                  } else {
                    attachedTax1.node = (
                      <TkDownloadLink
                        dataname={fileItem.formName ?? ""}
                        base64filedata={fileItem.file ?? ""}
                        onClick={(info: any) =>
                          fetchAndDownload(info, fileItem, res)
                        }
                      />
                    );
                  }
                  break;

                case FormClassRetire["退職所得の源泉徴収票_退職届2枚目"]:
                  let attachedTax2 = resArr.find(
                    (item) => item.keyword === "attachedTax2"
                  )!;
                  attachedTax2.showLine = true;
                  if (
                    res.page2WamDelFlgFromContractor === "0" &&
                    editableStatus
                  ) {
                    attachedTax2.node = getElm(res.fileList![index], "4", res);
                  } else {
                    attachedTax2.node = (
                      <TkDownloadLink
                        dataname={fileItem.formName ?? ""}
                        base64filedata={fileItem.file ?? ""}
                        onClick={(info: any) =>
                          fetchAndDownload(info, fileItem, res)
                        }
                      />
                    );
                  }
                  break;

                case FormClassRetire["退職所得の源泉徴収票_退職届3枚目"]:
                  let attachedTax3 = resArr.find(
                    (item) => item.keyword === "attachedTax3"
                  )!;
                  attachedTax3.showLine = true;
                  if (
                    res.page3WamDelFlgFromContractor === "0" &&
                    editableStatus
                  ) {
                    attachedTax3.node = getElm(res.fileList![index], "5", res);
                  } else {
                    attachedTax3.node = (
                      <TkDownloadLink
                        dataname={fileItem.formName ?? ""}
                        base64filedata={fileItem.file ?? ""}
                        onClick={(info: any) =>
                          fetchAndDownload(info, fileItem, res)
                        }
                      />
                    );
                  }
                  break;
              }
              break;
          }
        });

        //退職所得の源泉徴収表
        let page1RetireeTax = resArr.find(
          (item) => item.keyword === "page1RetireeTax"
        )!;
        let page2RetireeTax = resArr.find(
          (item) => item.keyword === "page2RetireeTax"
        )!;
        const isPage1RetireeTax = handleCheckExistFile(
          res.fileList!,
          "1",
          "RETIREE"
        );
        const isPage2RetireeTax = handleCheckExistFile(
          res.fileList!,
          "2",
          "RETIREE"
        );
        if (!res.page1WamDelFlg && !res.page2WamDelFlg) {
          // page1WamDelFlgとpage2WamDelFlgがどちらもnullの場合
          //・「受理待ち」「再受理待ち」の場合１枚目「追加」
          page1RetireeTax.showLine = addBtnVisibleRef.current;
          page1RetireeTax.node =
            addBtnVisibleRef.current && handleSetAddBtnElm(res, "1", "RETIREE");
          page2RetireeTax.showLine = false;
        } else if (res.page1WamDelFlg === "1" && res.page2WamDelFlg === "1") {
          page1RetireeTax.showLine = true;
          page1RetireeTax.node = handleSetDelAddBtnElm(res, "1", "RETIREE");
          page2RetireeTax.showLine = true;
          page2RetireeTax.node = handleSetDelAddBtnElm(res, "2", "RETIREE");
        } else if (!isPage1RetireeTax) {
          //1枚目のフォームクラス41なかったら（添付なし）
          page1RetireeTax.showLine = true;
          if (res.page1WamDelFlg === "1") {
            //削除フラグあり１→「機構ににて削除」「追加」
            page1RetireeTax.node = handleSetDelAddBtnElm(res, "1", "RETIREE");
            if (res.page2WamDelFlg === "0" && !isPage2RetireeTax) {
              page2RetireeTax.showLine = false;
            }
          } else if (res.page1WamDelFlg === "0" || !res.page1WamDelFlg) {
            //削除フラグなし０→
            //・「受理待ち」「再受理待ち」の場合２枚目「追加」
            page1RetireeTax.node =
              addBtnVisibleRef.current &&
              handleSetAddBtnElm(res, "1", "RETIREE");
            page1RetireeTax.showLine = addBtnVisibleRef.current;
            page2RetireeTax.showLine = false;
          }
        } else if (!isPage2RetireeTax) {
          // 2枚目のフォームクラス42なかったら（添付なし）
          if (res.page2WamDelFlg === "1") {
            // res.page1WamDelFlg === "1"の時は非表示
            if (res.page1WamDelFlg === "1") {
              page2RetireeTax.showLine = false;
            } else {
              // 　・削除フラグあり１→「機構ににて削除」「追加」
              page2RetireeTax.node = handleSetDelAddBtnElm(res, "2", "RETIREE");
              page2RetireeTax.showLine = true;
            }
          } else if (res.page2WamDelFlg === "0") {
            // 　・削除フラグなし０→
            if (res.page1WamDelFlg === "1") {
              // res.page1WamDelFlg === "1"の時は非表示
              page2RetireeTax.showLine = false;
            } else if (isPage1RetireeTax) {
              //1枚目合ったら
              //・「受理待ち」「再受理待ち」の場合２枚目「追加」
              page2RetireeTax.node =
                addBtnVisibleRef.current &&
                handleSetAddBtnElm(res, "2", "RETIREE");
              page2RetireeTax.showLine = addBtnVisibleRef.current;
            }
          }
        }
        handleCheckAppearFileParts(res, res, resArr);

        // 決裁日,記号番号
        let str = res.symbolNo?.substring(0, 2);
        let styleData;
        if (str === "共共") {
          styleData = "1";
        } else {
          styleData = "0";
        }
        if (res.symbolNo) {
          const start = res.symbolNo!.lastIndexOf("第") + 1;
          const last = res.symbolNo!.lastIndexOf("号");
          const num = res.symbolNo?.substring(start, last);
          res.latestApplyStatus === "13"
            ? setDefultData({
                symbolNumber: num,
                symbolNumberType: styleData,
                settlementDate: res.approvalDate,
              })
            : setDefultData({});
        }

        //【A】③　この申告書の提出先から受ける退職手当等の勤続期間（期間）
        let year = getTime(res.firstJoinDate, res.retireDate);
        resArr.find(
          (item) => item.keyword === "joinAndRetireDate"
        )!.setDefaultValue = year;

        // 【B】他の退職金の支払いの有無
        resArr.find(
          (item) => item.keyword === "otherRetireeMoneyYesOrNoPageB"
        )!.setDefaultValue = res.currentYearLosFrom ? "1" : "0";

        // 【C】他の退職金の支払いの有無
        resArr.find(
          (item) => item.keyword === "otherRetireeMoneyYesOrNoPageC"
        )!.setDefaultValue = res.past4yearsLosFrom ? "1" : "0";

        // 【C】⑦　③又は⑤の勤続期間のうち、⑥の勤続期間と重複している期間　開始
        //【A】③開始～終了
        const start1 = res.firstJoinDate!;
        const end1 = res.retireDate!;
        // 【B】⑤開始～終了
        const start2 = getEarlierTime(
          res.firstJoinDate,
          res.currentYearLosFrom
        );
        const end2 = getEarlierTime(res.retireDate, res.currentYearLosTo);
        // 【C】⑥勤続期間　開始～終了
        const start3 = res.past4yearsLosFrom!;
        const end3 = res.past4yearsLosTo!;
        // 【D】⑧開始～終了
        const start4 = res.pastLosInCurrentYearTotalFrom!;
        const end4 = res.pastLosInCurrentYearTotalTo!;

        const startData = getMaxStart(start1, start2, start3, end1, end2, end3);
        const endData = getMinEnd(start1, start2, start3, end1, end2, end3);

        let areaCNo7 = resArr.find((item) => item.keyword === "areaCNo7")!;
        areaCNo7.start = { wantToSetValue: startData, disabled: true };
        areaCNo7.end = { wantToSetValue: endData, disabled: true };

        // 【D】通算の有無
        resArr.find(
          (item) => item.keyword === "TotalOrNotPageD"
        )!.setDefaultValue =
          res.pastLosInCurrentYearTotalFrom ||
          res.pastLosInCurrentYearTotalTo ||
          res.pastLosInCurrentYearOtherFrom ||
          res.pastLosInCurrentYearOtherTo
            ? "1"
            : "0";

        // 【D】⑩　③又は⑤の勤続期間のうち、⑧又は⑨の勤続期間だけからなる部分の期間　開始
        const startData2 = getMaxStart(
          start1,
          start2,
          start4,
          end1,
          end2,
          end4
        );
        const endData2 = getMinEnd(start1, start2, start4, end1, end2, end4);
        let areaDNo10 = resArr.find((item) => item.keyword === "areaDNo10")!;
        areaDNo10.start = { wantToSetValue: startData2, disabled: true };
        areaDNo10.end = { wantToSetValue: endData2, disabled: true };

        // 【D】⑪ ⑦と⑩の通算期間
        let areaDNo11 = resArr.find((item) => item.keyword === "areaDNo11")!;
        areaDNo11.start = {
          wantToSetValue: getEarlierTime(startData2, startData),
          disabled: true,
        };
        areaDNo11.end = {
          wantToSetValue: getEarlierTime(endData2, endData),
          disabled: true,
        };

        // 【E】B欄又はC欄の退職手当等の有無
        let isHave;
        if (res.currentYearLosFrom || res.past4yearsLosFrom) {
          isHave = "1";
        } else {
          isHave = "0";
          resArr
            .filter((_v, i) => i > 78 && i < 101)
            ?.forEach((item) => (item.showLine = false));
        }
        resArr.find(
          (item) => item.keyword === "RetirementAllowancePageE"
        )!.setDefaultValue = isHave;

        let bodyListApproval = [
          [{ children: res.approvalDate }, { children: res.symbolNo }],
        ];
        setBodyList(bodyListApproval);

        setStateTableList([...resArr]);
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const makeHttpObj = (num: any, formData?: any): IAPI_APP016_Request => {
    let resData: IAPI_APP016_Request = {
      applyEvent: num,
      reason: memoData,
      applyId: applyId ?? responseData?.applyId,
      contractorNo,
      screenId: "SCRW410001",
      ...(memoCheck && { inquiryCode: "3" }),
      ...(num === applyEvent["受理"] &&
        !!formData && { limitationAbolitionApprovalDate: formData }),
      ...(num === applyEvent["承認"] && {
        symbolNo:
          TkGetCode(CommonOrCommonRetirementFlug, formData.symbolNumberType) +
          "第" +
          formData.symbolNumber +
          "号",
        decisionDate: formData.settlementDate,
      }),
    };

    return resData;
  };

  const btnEvent = async (btnName: any) => {
    const num =
      btnName === "契約者に差戻し"
        ? "5"
        : btnName === "受理"
        ? "2"
        : btnName === "承認"
        ? "3"
        : btnName === "担当者に差戻し"
        ? "8"
        : btnName === "課長代理確認"
        ? "14"
        : btnName === "上長承認"
        ? "6"
        : "";

    if (num === "") {
      return;
    }
    if (num === "2" && responseData?.limitationFlg === "1") {
      setOpenLimitationAbolitionApprovalDate(true);
      return;
    }

    if (num === "3") {
      setIsOpen(true);
      return;
    }

    handleUpdate(num);
  };

  const onChange = (event: any) => {
    if (event.target.type === "input") {
      setMemoData(event.target.value);
    } else {
      setMemoCheck(event.target.value);
    }
  };

  const handleUpdate = async (applyEvent: any, data?: any) => {
    let reqData: IAPI_APP016_Request = makeHttpObj(applyEvent, data);

    try {
      const res = await httpAPI_APP016({
        ...reqData,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRW110001");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const setOpen = () => {
    setIsOpen(false);
  };

  const goToDetail = () => {
    setBusinessState({
      ...businessState,
      job_35: {
        ...businessState.job_35,
        applyId,
        staffNo,
      },
    });
    navigate("/SCRW060004", {
      state: { applyId: responseData?.retirementFormApplyId, staffNo },
    });
  };

  return (
    <Box data-testid="SCRW410001PageForTest" className="SCRW410001">
      <TkKikoStepper
        applicationFlowType={"TYPE2"}
        businessType={"JOB-35"}
        applicationStatus={statusCd}
        corporateApplicationClassification={corpApplyKbn}
      />

      <TkInfoManual rule={"\\n"}>{labelids.labelid.LBLW410001_01}</TkInfoManual>
      <Box>
        <TkContractorAndNumberLine
          name="契約者（法人）名"
          no={
            (contractorNo ?? "") + ":" + businessState?.common?.contractorName
          }
        />
        <TkFakeTable list={stateTableList} ruleSchema={{}} showButton={false} />
        <TkMemo
          showTable={true}
          bodyList={tkMemoBodyList}
          onChange={onChange}
        ></TkMemo>

        {isStatusAfterApproval(statusCd) && (
          <TkTableWithNoLine headList={headList} bodyList={bodyList} />
        )}

        <Box className="btnGroup">
          <TkBackButton
            className="tkBottonMr"
            useBackParam
            navigateParam={{ contractorNo }}
          />
          <TkViewButtonJudgement
            flowType={"TYPE2"}
            Status={statusCd}
            onClick={btnEvent}
            businessType={businessState.common?.businessType}
          />
          <TkButton onClick={goToDetail} disabled={disabledReferBtn.current}>
            退職届参照
          </TkButton>
        </Box>

        <TkApprovalDateSymbolNumberRegistrationDialog
          data-testid="SCRW080004PageForDialog"
          open={isOpen}
          onSuccess={(e: any) => handleUpdate(applyEvent["承認"], e)}
          onClose={setOpen}
          wantToSetValue={defultData}
        />

        <TkDateDialog
          open={openLimitationAbolitionApprovalDate}
          title="時効撤廃承認日"
          okText="登録"
          minDate={new Date("1900/01/01")}
          maxDate={new Date()}
          onOky={(e: any) => handleUpdate(applyEvent["受理"], e)}
          onCancel={() => setOpenLimitationAbolitionApprovalDate(false)}
        />
      </Box>
    </Box>
  );
};

export default SCRW410001;
